export const AccessSourceType = ['firm', 'firm-membership', 'group', 'user', 'special'];
export const AuthenticatedUser = 'authenticated-users';
export const AnyUser = 'everyone';
export const PublicUser = 'anonymous-users';
const SpecialPermissionSubjects = {
    [AuthenticatedUser]: AuthenticatedUser,
    [AnyUser]: AnyUser,
    [PublicUser]: PublicUser,
};
const SpecialPermissionSubjectsArray = Object.values(SpecialPermissionSubjects);
export { SpecialPermissionSubjectsArray as SpecialPermissionSubjects };
export function isSpecialPermissionSubject(subject) {
    return subject in SpecialPermissionSubjects;
}
export const PermissionType = ['reader', 'writer', 'owner', 'admin'];
//# sourceMappingURL=permissions.js.map